/* Search overlay behaviour, ported from the homepage-navigation prototype (assets/js/search.js).
   Results come from Shopify predictive search (section_id=cq-predictive-search, the overlay's own section, A3-5);
   requests are debounced, cancelled with an AbortController, cached, and version-checked so a late reply never paints
   over a newer one. The feed (popular replacements, part numbers, guides, quick links) shows for an empty field, under a
   no-results message and under thin results, and on phones in short form under every answer (A3). */

/* Typing search prompt: window.CQSearchType (AJ 2026-10-11; it replaced the fading placeholder rotator).
   Hook: <span data-cq-search-type="Search for|cartridges|filters|a SKU or part number">static prompt</span> inside the
   header's desktop search field (sections/cq-header.liquid). The first part is the lead that stays; the rest are the
   words it cycles: it types "Search for cartridges", pauses, backspaces the word, types the next one and so on. An
   optional data-cq-search-end line (AJ 2026-10-11 09:12: "Start my quest for crystal clear water") follows the last
   word: the whole text is deleted, the line is typed on its own, held a little longer, deleted, and the loop restarts.
   It stops the moment the field gets focus or the search sheet opens (showing the static prompt it was rendered with)
   and starts again after focus leaves. It waits, without changing the text, while the page is hidden or the field is not
   shown (below 1440 px the header shows the icon only). prefers-reduced-motion: the static prompt only. The span is aria-hidden and the
   field's accessible name is the static prompt; the field has a fixed width in assets/cq-header.css, so the changing
   text never moves layout. Call CQSearchType.init(root) after injecting new markup; it runs on load and on
   shopify:section:load. */
(function () {
  if (window.CQSearchType) return;
  var TYPE = 70, ERASE = 36, HOLD = 1800, HOLD_END = 2800, GAP = 320, WAIT = 1000;
  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  /* A7-4d: the header shows the typing field from 1440 px (assets/cq-header.css, .nav-srch__type); a media query answers
     "is it on screen" without the layout getClientRects() forced after every typed letter */
  var wide = window.matchMedia ? window.matchMedia('(min-width: 1440px)') : { matches: true };
  var typers = [];

  function Typer(el) {
    var parts = (el.getAttribute('data-cq-search-type') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    var self = this;
    this.el = el;
    this.base = parts.length ? parts.shift() + ' ' : '';
    /* each line: its full text, and whether it is a word after the lead (only those erase back to the lead) */
    this.words = parts.map(function (w) { return { text: self.base + w, word: true }; });
    var end = (el.getAttribute('data-cq-search-end') || '').trim();
    if (end) this.words.push({ text: end, word: false });
    this.fixed = el.textContent;
    this.host = el.closest('a, button, label, form') || el;
    this.timer = null;
    this.on = false;
    this.host.addEventListener('focusin', function () { self.halt(); });
    this.host.addEventListener('focusout', function () { self.go(); });
  }
  Typer.prototype.sheetOpen = function () { var d = document.getElementById('search'); return !!(d && d.open); };
  Typer.prototype.later = function (ms) { var self = this; clearTimeout(this.timer); this.timer = setTimeout(function () { self.step(); }, ms); };
  Typer.prototype.show = function (text) { this.text = text; this.el.textContent = text; };
  Typer.prototype.halt = function () {
    clearTimeout(this.timer);
    this.on = false;
    this.el.classList.remove('is-typing');
    this.el.textContent = this.fixed;
  };
  Typer.prototype.go = function () {
    if (reduced.matches || !this.words.length || !this.el.isConnected) return;
    if (this.host.matches(':focus-within') || this.sheetOpen()) { this.wake(); return; }
    this.on = true;
    this.index = 0;
    this.phase = 'type';
    this.target = this.words[0].text;
    this.el.classList.add('is-typing');
    this.show('');
    this.later(GAP);
  };
  Typer.prototype.step = function () {
    if (!this.on) return;
    if (!this.el.isConnected) { this.halt(); return; }
    if (this.host.matches(':focus-within') || this.sheetOpen()) { this.halt(); this.wake(); return; }
    if (document.hidden || !wide.matches) { this.later(WAIT); return; }
    var t = this.text;
    if (this.phase === 'type') {
      if (t.length < this.target.length) { this.show(this.target.slice(0, t.length + 1)); this.later(TYPE + Math.random() * 40); }
      else { this.phase = 'erase'; this.later(this.words[this.index].word ? HOLD : HOLD_END); }
    } else if (this.phase === 'erase') {
      var next = (this.index + 1) % this.words.length;
      var floor = this.words[this.index].word && this.words[next].word ? this.base.length : 0;
      if (t.length > floor) { this.show(t.slice(0, -1)); this.later(ERASE); }
      else { this.index = next; this.target = this.words[next].text; this.phase = 'type'; this.later(GAP); }
    }
  };
  /* After the sheet closes (focus returns elsewhere than the field), start again once it is shut. */
  Typer.prototype.wake = function () {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function check() {
      if (self.on) return;
      if (self.sheetOpen() || self.host.matches(':focus-within')) { self.timer = setTimeout(check, WAIT); return; }
      self.go();
    }, WAIT);
  };

  function init(root) {
    (root || document).querySelectorAll('[data-cq-search-type]').forEach(function (el) {
      if (el.__cqType) return;
      el.__cqType = new Typer(el);
      typers.push(el.__cqType);
      el.__cqType.go();
    });
  }

  if (reduced.addEventListener) reduced.addEventListener('change', function () {
    typers.forEach(function (t) { if (reduced.matches) t.halt(); else t.go(); });
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.CQSearchType = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
if (!customElements.get('cq-search')) {
  customElements.define('cq-search', class extends HTMLElement {
    connectedCallback() {
      if (this.cqEvents) return;
      this.cqEvents = new AbortController();
      const on = (target, type, fn, opts) => target && target.addEventListener(type, fn, Object.assign({ signal: this.cqEvents.signal }, opts || {}));
      this.dialog = this.querySelector('dialog');
      this.sheet = this.querySelector('.srch__sheet');
      this.input = this.querySelector('#srch-input');
      this.clearBtn = this.querySelector('.srch__clear');
      this.feedEl = this.querySelector('[data-srch-feed]');
      this.resultsEl = this.querySelector('[data-srch-results]');
      this.skuSlot = this.querySelector('[data-srch-sku-slot]');
      this.listEl = this.querySelector('#srch-list');
      this.noneEl = this.querySelector('[data-srch-none]');
      this.statusEl = this.querySelector('[data-srch-status]');
      this.cache = new Map();
      this.version = 0;
      this.active = -1;
      this.mqReduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mqBar = matchMedia('(min-width: 1024px)');
      this.mqPhone = matchMedia('(max-width: 767px)');
      /* A6-05 (fix wave 2026-10-14): phones open the feed's first group (Popular searches) by default, so the empty sheet
         offers something to tap at once; the rest stay collapsed. Wider screens show every group open anyway. */
      const firstAcc = this.querySelector('.srch-acc');
      if (firstAcc) { firstAcc.classList.add('is-open'); firstAcc.querySelector('.srch-acc__btn')?.setAttribute('aria-expanded', 'true'); }

      /* Load the best-selling parts for the feed on the first sign of intent, so the slots are filled before the sheet opens. */
      const intent = (e) => { if (e.target.closest && e.target.closest('[data-cq-search-open]')) this.loadParts(); };
      on(document, 'pointerover', intent, { passive: true });
      on(document, 'focusin', intent);
      on(document, 'touchstart', intent, { passive: true });

      /* Openers anywhere on the page: the header field, panel chips with a query, the part-number finder. */
      on(document, 'click', (e) => {
        const opener = e.target.closest('[data-cq-search-open]');
        if (opener) { e.preventDefault(); this.open({ source: opener }); return; }
        const chip = e.target.closest('[data-search-query]');
        if (chip && !this.contains(chip)) { e.preventDefault(); this.open({ source: chip, query: chip.dataset.searchQuery }); }
      });
      on(document, 'submit', (e) => {
        const form = e.target.closest('[data-finder-form]');
        if (!form) return;
        e.preventDefault();
        const q = (form.querySelector('input[name="q"]')?.value || '').trim();
        this.open({ source: form.querySelector('input') || form, query: q });
      });
      on(document, 'keydown', (e) => {
        const t = e.target;
        const typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
        const isK = (e.metaKey || e.ctrlKey) && !e.altKey && (e.key === 'k' || e.key === 'K');
        const isSlash = e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey;
        if (isK && this.dialog.open && t === this.input) { e.preventDefault(); this.close(); return; }
        if (!isK && !isSlash) return;
        if (typing || this.dialog.open) return;
        this.loadParts();
        if (document.body.classList.contains('drawer-open') || document.querySelector('dialog[open], product-compare-modal[open]') || document.documentElement.classList.contains('cqp-locked')) return;
        e.preventDefault();
        this.open({ source: document.querySelector('[data-cq-search-open]') });
      });

      /* Adding a part to the cart hands focus to the native cart drawer. */
      on(document, 'cart-drawer:before-open', (event) => {
        if (!this.dialog.open) return;
        if (event.detail && this.contains(event.detail.opener)) event.detail.opener = this.opener;
        this.restoreCartFocus = true;
        this.close({ handoff: true });
      });
      on(document, 'cart-drawer:open', () => {
        if (!this.restoreCartFocus) return;
        this.restoreCartFocus = false;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          const drawer = document.querySelector('cq-cart-drawer');
          if (drawer?.isOpen) drawer.focusFirst();
        }));
      });

      on(this.dialog, 'cancel', (e) => { e.preventDefault(); this.close(); });
      /* r11 item 1: however the dialog ends up closed, the shared scroll lock is released */
      on(this.dialog, 'close', () => { window.cqScrollLock?.unlock(this); this.endBar(); });
      /* the grown field follows the header bar if the window is resized; below 1024 px it closes */
      on(window, 'resize', () => {
        if (this.dialog.open && this.dialog.classList.contains('is-bar') && !this.measureBar()) this.close({ instant: true });
      });
      on(this.dialog, 'keydown', (e) => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); this.close(); } });
      on(this.input, 'input', () => {
        clearTimeout(this.debounce);
        this.setActive(-1);
        this.clearBtn.hidden = !this.input.value;
        this.debounce = setTimeout(() => this.run(), 120);
      });
      on(this.input, 'keydown', (e) => {
        const count = this.options().length;
        if (e.key === 'ArrowDown') { if (!count) return; e.preventDefault(); this.setActive(this.active < 0 ? 0 : (this.active + 1) % count); }
        else if (e.key === 'ArrowUp') { if (!count) return; e.preventDefault(); this.setActive(this.active <= 0 ? count - 1 : this.active - 1); }
      });
      on(this.querySelector('.srch__bar'), 'submit', (e) => {
        const q = this.input.value.trim();
        if (!q) { e.preventDefault(); return; }
        const opts = this.options();
        if (this.active >= 0 && opts[this.active] && !this.resultsEl.hidden) { e.preventDefault(); opts[this.active].click(); return; }
        const exact = this.skuSlot.querySelector('.srch-sku__title a');
        if (exact && this.lastQuery === this.input.value) { e.preventDefault(); window.location.href = exact.href; return; }
        this.input.value = this.rewrite(q);
        /* otherwise the form submits to the full search page */
      });
      on(this.clearBtn, 'click', () => { this.input.value = ''; this.clearBtn.hidden = true; this.render(null); this.input.focus(); });
      on(this, 'click', (e) => {
        if (e.target.closest('[data-srch-close]')) { this.close(); return; }
        /* phones: the feed's groups open and close in place (cq-search-feed.liquid .srch-acc) */
        const acc = e.target.closest('.srch-acc__btn');
        if (acc) {
          const group = acc.closest('.srch-acc');
          const open = !group.classList.contains('is-open');
          group.classList.toggle('is-open', open);
          acc.setAttribute('aria-expanded', String(open));
          return;
        }
        const chip = e.target.closest('.srch-chip, a[data-q]');
        if (chip && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
          e.preventDefault();
          this.input.value = chip.dataset.q || chip.textContent.trim();
          this.clearBtn.hidden = false;
          this.run(true);
          this.input.focus();
          this.querySelector('.srch__body').scrollTop = 0;
          return;
        }
        const link = e.target.closest('a[href]');
        if (link && this.contains(link)) this.close({ noFocus: true, instant: true });
      });
      /* delegated from the results area: the listbox element itself is replaced on every render (see render) */
      on(this.resultsEl, 'mousemove', (e) => {
        const o = e.target.closest('#srch-list [role="option"]');
        if (!o) return;
        const i = this.options().indexOf(o);
        if (i !== this.active) this.setActive(i, false);
      });
    }

    disconnectedCallback() {
      clearTimeout(this.debounce);
      this.request?.abort();
      this.cqEvents?.abort();
      this.cqEvents = null;
    }

    /* r3: the header's Search rewrites (cq-search-help.js) fix misspellings before predictive search and on submit */
    rewrite(q) { const h = window.CQSearchHelp; return (h?.rewrite ? h.rewrite(q) : h?.normalizePartQuery(q)) || String(q || '').trim(); }

    /* r3 (AJ 2026-10-14: "make it 3 so they dont have to [scroll] ... responsive based on phone size"): phones show four
       product rows when See all results then fits on the visible screen, else three (never fewer). Measured once per
       answer against the visual viewport, which shrinks while the on-screen keyboard is open, so browser bars, the
       keyboard and text zoom all count. Once three is chosen it stays three while the sheet is open unless the visible
       height grows by 80 px or more (the keyboard closed), so the count does not flip between keystrokes. Without this
       measure cq-search.css shows three on short screens (.srch-results:not(.is-rows-4), max-height 699px).
       r3f-v1 (V1 S-1): an exact part card (.srch-sku-slot) above the rows is measured too: with a card the rows step
       down below three, to none (card, then See all, as for a part with no other matches), until See all fits. */
    fitRows() {
      const box = this.resultsEl;
      box.classList.remove('is-rows-0', 'is-rows-1', 'is-rows-2', 'is-rows-3', 'is-rows-4');
      const all = this.listEl.querySelector('.srch-opt--all');
      const card = !!this.skuSlot.querySelector('.srch-sku');
      const rows = this.listEl.querySelectorAll('.srch-prods > .srch-opt:not(.srch-opt--extra)').length;
      if (this.dialog.classList.contains('is-bar') || !this.mqPhone.matches || !all || rows < (card ? 1 : 4)) return;
      const vv = window.visualViewport;
      const seen = vv ? vv.offsetTop + vv.height : window.innerHeight;
      const body = this.querySelector('.srch__body');
      const fits = () => all.getBoundingClientRect().bottom + (body ? body.scrollTop : 0) + 8 <= seen;
      if (card) {
        for (let n = Math.min(rows, 4); n >= 0; n--) { box.classList.add(`is-rows-${n}`); if (!n || fits()) return; box.classList.remove(`is-rows-${n}`); }
      }
      box.classList.add('is-rows-4');
      if (fits() && !(this.rows3At && seen < this.rows3At + 80)) { this.rows3At = 0; return; }
      box.classList.replace('is-rows-4', 'is-rows-3');
      if (!this.rows3At || seen < this.rows3At) this.rows3At = seen;
    }

    /* r3: a best match from the header's Search best matches setting goes first, in its own group */
    addBest(query) {
      const best = window.CQSearchHelp?.shortcut?.(query);
      if (!best) return false;
      const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
      const group = el('div', 'srch-group srch-group--best');
      group.setAttribute('role', 'group');
      group.setAttribute('aria-labelledby', 'srch-g-best');
      const label = el('div', 'srch-label', this.dataset.tBest || 'Best match');
      label.id = 'srch-g-best';
      const a = el('a', 'srch-opt srch-opt--best');
      Object.assign(a, { id: 'srch-ob', href: best.url, tabIndex: -1 });
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      const text = el('span', 'srch-opt__text');
      text.append(el('span', 'srch-opt__title', best.label));
      if (best.note) text.append(el('span', 'srch-opt__sub', best.note));
      a.append(text);
      group.append(label, a);
      this.listEl.prepend(group);
      return true;
    }

    /* only options on screen: phones hide product rows past the first three or four (fitRows), and Guides and Pages under a shoppable
       answer (A3, cq-search.css), so arrow keys and aria-activedescendant skip them */
    options() { return Array.from(this.listEl.querySelectorAll('[role="option"]')).filter((o) => o.getClientRects().length); }

    /* Fill the feed's part slots with the best-selling parts, cached for the session. Falls back to the next
       best-selling cartridges (template[data-srch-part-fallback]) if the parts cannot be loaded. */
    loadParts() {
      if (this.partsState) return;
      const slots = this.querySelectorAll('[data-srch-part-slot]');
      if (!slots.length || !this.dataset.partsUrl) { this.partsState = 'done'; return; }
      this.partsState = 'loading';
      const key = 'cq-search-parts-v1';
      const fill = (html) => {
        const box = document.createElement('template');
        box.innerHTML = html;
        const tiles = Array.from(box.content.querySelectorAll('.srch-tiles__item'));
        if (!tiles.length) return false;
        this.querySelectorAll('[data-srch-part-slot]').forEach((slot, i) => { if (tiles[i]) slot.replaceWith(tiles[i]); else slot.remove(); });
        this.partsState = 'done';
        return true;
      };
      const fallback = () => {
        const tpl = this.querySelector('template[data-srch-part-fallback]');
        if (!tpl || !fill(tpl.innerHTML)) this.querySelectorAll('[data-srch-part-slot]').forEach((slot) => slot.remove());
        this.partsState = 'done';
      };
      try {
        const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (cached && cached.html && Date.now() - cached.t < 6 * 3600e3 && fill(cached.html)) return;
      } catch (e) { /* storage blocked: fetch instead */ }
      fetch(this.dataset.partsUrl, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error('parts unavailable'); return r.text(); })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const tpl = doc.querySelector('template[data-cq-search-parts]');
          const html = tpl ? tpl.innerHTML : '';
          if (!fill(html)) { fallback(); return; }
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), html })); } catch (e) { /* ignore */ }
        })
        .catch(fallback);
    }
    reduced() { return this.mqReduced.matches; }

    /* Desktop (AJ 2026-10-11 09:12 "instead of it opening a new search bar window ... just literally grow"): the sheet's
       field is drawn over the header bar, starting exactly on the header search field, and grows across the bar while the
       bar's other items fade out (.is-searching on the header); the results open in place under it (assets/cq-search.css,
       .is-bar). Phones and tablets keep the sheet. Returns false when the header field is not on screen. */
    measureBar() {
      this.nav = document.querySelector('cq-header [data-nav]');
      const src = this.nav?.querySelector('.nav-srch');
      const inner = this.nav?.querySelector('.nav-bar__inner');
      if (!this.mqBar.matches || !src || !inner || !src.getClientRects().length) return false;
      const bar = this.nav.querySelector('.nav-bar').getBoundingClientRect();
      const box = inner.getBoundingClientRect();
      const pad = getComputedStyle(inner);
      const f = src.getBoundingClientRect();
      const top = Math.max(0, bar.top);
      const x = box.left + parseFloat(pad.paddingLeft);
      const w = box.right - parseFloat(pad.paddingRight) - x;
      const set = (k, v) => this.dialog.style.setProperty(k, Math.round(v) + 'px');
      set('--sb-top', top);
      set('--sb-bot', bar.bottom + (parseFloat(getComputedStyle(this.nav).getPropertyValue('--nav-shift')) || 0));
      set('--sb-x', x);
      set('--sb-w', w);
      set('--sb-r', document.documentElement.clientWidth - x - w);
      set('--f0x', f.left);
      set('--f0y', f.top - top);
      set('--f0w', f.width);
      set('--f0h', f.height);
      return true;
    }
    endBar() {
      this.dialog.classList.remove('is-bar');
      this.nav?.classList.remove('is-searching', 'is-srch-open', 'is-srch-sheet');
    }
    /* the phone sheet closes on the menu's timing (--srch-t-sheet, cq-search.css); the desktop bar and tablets in 280 ms */
    sheetMs() {
      const v = getComputedStyle(this).getPropertyValue('--srch-t-sheet').trim();
      const ms = v.endsWith('ms') ? parseFloat(v) : parseFloat(v) * 1000;
      return this.dialog.classList.contains('is-bar') || !Number.isFinite(ms) ? 280 : ms;
    }

    open(detail = {}) {
      if (this.dialog.open) {
        /* opened again while it closes: stay open */
        if (!this.dialog.classList.contains('is-open')) { clearTimeout(this.closeTimer); this.dialog.classList.add('is-open'); this.nav?.classList.add(this.dialog.classList.contains('is-bar') ? 'is-searching' : 'is-srch-sheet'); }
        if (detail.query) { this.input.value = detail.query; this.run(true); }
        this.input.focus();
        return;
      }
      /* opened again during a phone close (.is-closing, the dialog already left the top layer): start a fresh open */
      if (this.dialog.classList.contains('is-closing')) {
        this.endClosing();
        this.dialog.classList.remove('is-open');
        this.endBar();
        document.documentElement.classList.remove('cqp-locked');
      }
      clearTimeout(this.closeTimer);
      this.rows3At = 0;
      /* A3: from inside the phone menu the search takes over the menu's white sheet at once instead of revealing again.
         The menu closes itself on the tap before this runs, so the tapped element says where it came from. */
      const fromMenu = !!(detail.source?.closest?.('.mnav') || document.querySelector('.cqp.mnav[open]'));
      const header = document.querySelector('cq-header');
      header?.closeAll?.();
      /* focus goes back where the shopper started: a source inside the phone sheet returns to the header search, and a
         source inside a desktop panel (the part-number finder) returns to that panel's top item, because the panel
         closes when the sheet opens */
      const src = detail.source;
      const panel = src?.closest?.('[data-nav-panel]');
      this.opener = src?.closest?.('.mnav') ? document.querySelector('.nav-srch') : panel ? (document.querySelector(`[data-nav-trigger="${panel.dataset.navPanel}"]`) || document.querySelector('.nav-srch')) : (src || document.activeElement);
      /* the exact-part Add to cart needs the theme's product form; load it on first use */
      if (!customElements.get('product-form') && !document.querySelector('script[data-cq-product-form]')) {
        const s = document.createElement('script');
        s.src = this.dataset.productForm; s.defer = true; s.dataset.cqProductForm = '';
        document.head.appendChild(s);
      }
      this.loadParts();
      if (this.measureBar()) { this.dialog.classList.add('is-bar'); this.nav.classList.add('is-searching', 'is-srch-open'); }
      /* phones: the sheet starts where the menu does, under the navy strip while it is on screen (cq-search.css --srch-top) */
      else this.dialog.style.setProperty('--srch-top', Math.max(0, this.nav?.getBoundingClientRect().top || 0) + 'px');
      this.dialog.classList.toggle('is-instant', fromMenu);
      /* phones: the large field's prompt is the short word Search (the full prompt would be cut off at 24 px); the field's
         name stays its label */
      this.input.dataset.placeholder ??= this.input.placeholder;
      this.input.placeholder = !this.dialog.classList.contains('is-bar') && matchMedia('(max-width: 767px)').matches && this.dataset.tShort ? this.dataset.tShort : this.input.dataset.placeholder;
      /* phones: the header's hamburger turns into the X under the sheet's own X (cq-header.css .is-srch-sheet) */
      this.nav?.classList.toggle('is-srch-sheet', !this.dialog.classList.contains('is-bar'));
      this.dialog.showModal();
      /* r11 item 1: the shared scroll lock (assets/cq-scroll-lock.js) holds the page; cqp-locked is a state hook only */
      window.cqScrollLock?.lock(this, { root: this.dialog, isOpen: () => this.dialog.open });
      document.documentElement.classList.add('cqp-locked');
      if (detail.query != null) this.input.value = detail.query;
      void this.dialog.offsetWidth;
      this.dialog.classList.add('is-open');
      if (fromMenu) requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.remove('is-instant')));
      this.input.focus({ preventScroll: true });
      this.clearBtn.hidden = !this.input.value;
      if (this.input.value) { this.input.select(); this.run(true); } else this.render(null);
    }

    close(opts = {}) {
      if (!this.dialog.open) return;
      clearTimeout(this.debounce);
      this.request?.abort();
      this.version++;
      this.dialog.classList.remove('is-open');
      this.nav?.classList.remove('is-searching', 'is-srch-sheet');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      const finish = () => {
        this.dialog.close();
        this.endBar();
        window.cqScrollLock?.unlock(this);
        if (!opts.handoff) document.documentElement.classList.remove('cqp-locked');
        if (!opts.handoff && !opts.noFocus && this.opener?.focus && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
      };
      if (opts.handoff) document.documentElement.classList.remove('cqp-locked');
      /* a hand-off (the cart drawer opening) must leave the top layer at once so the drawer can take focus */
      if (opts.instant || opts.handoff || this.reduced()) { finish(); return; }
      /* r3f-v1 (V1 S-2): the phone sheet leaves the top layer at once (the page stops being inert, so focus goes back
         to the opener now and keys typed during the close land there, not in the field); .is-closing keeps it drawn
         and inert while the menu's curve runs (cq-search.css) */
      if (this.mqPhone.matches && !this.dialog.classList.contains('is-bar')) {
        this.dialog.classList.add('is-closing');
        this.dialog.inert = true;
        this.dialog.close();
        if (!opts.noFocus && this.opener?.focus && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
        opts.noFocus = true;
      }
      this.closeTimer = setTimeout(() => { this.endClosing(); finish(); }, this.sheetMs());
    }
    endClosing() { clearTimeout(this.closeTimer); this.dialog.classList.remove('is-closing'); this.dialog.inert = false; }

    setActive(i, scroll = true) {
      const opts = this.options();
      opts.forEach((o) => { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
      if (!opts.length || i < 0) { this.active = -1; this.input.removeAttribute('aria-activedescendant'); return; }
      this.active = Math.max(0, Math.min(i, opts.length - 1));
      const el = opts[this.active];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', el.id);
      if (scroll) el.scrollIntoView({ block: 'nearest' });
    }

    run(immediate = false) {
      clearTimeout(this.debounce);
      this.request?.abort();
      const raw = this.input.value;
      const query = this.rewrite(raw);
      this.querySelector('cq-search-help')?.update?.(raw);
      this.clearBtn.hidden = !raw;
      const version = ++this.version;
      if (!query) { this.render(null); return; }
      const key = query.toLowerCase();
      if (this.cache.has(key)) {
        /* FC-15: a cached answer takes the network path too: the feed is hidden for one painted frame, then the answer
           renders, so text filled in without a key press (suggestion, dictation, autofill) never moves the feed on
           screen. The version check drops a frame that a newer query has overtaken. */
        this.feedEl.hidden = true;
        requestAnimationFrame(() => requestAnimationFrame(() => this.render(this.cache.get(key), raw, version)));
        return;
      }
      this.resultsEl.classList.add('is-loading');
      /* Hide the feed while the answer loads: if it returns under the results it appears fresh instead of
         being pushed down, so nothing that was on screen moves (no layout shift). */
      this.feedEl.hidden = true;
      this.statusEl.textContent = this.dataset.tLoading;
      const go = () => this.fetchResults(query, key, raw, version);
      if (immediate) go(); else this.debounce = setTimeout(go, 80);
    }

    async fetchResults(query, key, raw, version) {
      this.request = new AbortController();
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,article,page',
        /* ten of each type, the Predictive Search API maximum: up to ten products in the main column, and the side
           column (Collections, Guides, Pages) picks its few from the rest (snippets/cq-search-results.liquid) */
        'resources[limit]': '10',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,product_type,variants.title,variants.sku',
        'resources[options][unavailable_products]': 'last',
        /* A3-5: the overlay's own section renders only the results template, not the old Dawn list */
        section_id: 'cq-predictive-search',
      });
      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.request.signal });
        if (!response.ok) throw new Error('search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const template = doc.querySelector('template[data-cq-search-results]');
        if (!template) throw new Error('missing results');
        const html = template.innerHTML;
        if (this.cache.size >= 30) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(key, html);
        this.render(html, raw, version);
      } catch (error) {
        if (error.name === 'AbortError' || version !== this.version || !this.dialog.open) return;
        this.renderError(raw);
      }
    }

    render(html, raw, version) {
      if (version != null && version !== this.version) return;
      this.active = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.resultsEl.classList.remove('is-loading');
      if (html == null) {
        this.querySelector('cq-search-help')?.update?.('');
        this.feedEl.hidden = false;
        this.feedEl.classList.remove('is-below', 'is-extra');
        this.resultsEl.hidden = true;
        this.skuSlot.replaceChildren();
        this.listEl.replaceChildren();
        this.input.setAttribute('aria-expanded', 'false');
        this.statusEl.textContent = '';
        this.lastQuery = '';
        return;
      }
      this.lastQuery = raw;
      const box = document.createElement('div');
      box.innerHTML = html;
      const payload = box.querySelector('.srch-payload') || box;
      const sku = payload.querySelector('.srch-sku');
      const list = payload.querySelector('.srch-list-src');
      /* P1 (a), fix wave 2026-10-14: phones put See all results right under More products, above Collections, so it shows
         without scrolling on short phones (320x568, 375x667). Moved in the DOM, not with CSS order, so arrow keys and
         screen readers follow what is seen; wider screens keep it last, under both columns. */
      const allGroup = this.mqPhone.matches && list?.querySelector(':scope > .srch-group--all');
      const mainCol = allGroup && list.querySelector(':scope > .srch-main');
      if (mainCol && list.querySelector(':scope > .srch-side')) mainCol.after(allGroup);
      this.skuSlot.replaceChildren(...(sku ? [sku] : []));
      this.swapList(list ? [list] : []);
      const query = this.rewrite(raw);
      const best = this.addBest(query);
      this.highlight(query);
      const count = Number(payload.dataset.count || 0);
      const hasAny = count > 0 || !!sku || best;
      const thin = payload.dataset.thin === '1';
      /* never a dead end: the feed stays under a no-results message and under thin results. Under a strong answer it
         is hidden (.is-extra) on every screen: phones too since AJ 2026-10-14 15:29 (only what matches the typing) */
      this.feedEl.hidden = false;
      this.feedEl.classList.add('is-below');
      this.feedEl.classList.toggle('is-extra', hasAny && !thin);
      this.resultsEl.hidden = false;
      this.resultsEl.classList.toggle('is-none', !hasAny);
      this.noneEl.hidden = hasAny;
      if (!hasAny) {
        const title = this.noneEl.querySelector('[data-srch-none-title]');
        title.textContent = title.dataset.template.replace('__QUERY__', raw.trim());
      }
      this.fitRows();
      /* announce what is on screen (phones hide some rows), not counting the More products and See all links */
      const opts = this.options();
      const shown = opts.filter((o) => !o.matches('.srch-opt--all, .srch-opt--more')).length;
      this.input.setAttribute('aria-expanded', opts.length ? 'true' : 'false');
      this.statusEl.textContent = sku ? this.dataset.tCountSku.replace('__COUNT__', shown) : (shown ? this.dataset.tCount.replace('__COUNT__', shown) : this.dataset.tNone);
    }

    /* New answers go into a fresh listbox element (same id, role and name). An exact part-number card appearing
       or leaving above the list would otherwise move the existing list node, which the browser counts as a
       layout shift; a newly inserted node does not shift. */
    swapList(children) {
      const fresh = this.listEl.cloneNode(false);
      fresh.append(...children);
      this.listEl.replaceWith(fresh);
      this.listEl = fresh;
    }

    renderError(raw) {
      this.setActive(-1);
      this.lastQuery = raw;
      this.resultsEl.classList.remove('is-loading');
      this.feedEl.hidden = false;
      this.feedEl.classList.add('is-below');
      /* an error keeps the whole feed, as no results does (A3) */
      this.feedEl.classList.remove('is-extra');
      this.resultsEl.classList.add('is-none');
      this.resultsEl.hidden = false;
      this.skuSlot.replaceChildren();
      const a = document.createElement('a');
      a.className = 'srch-opt srch-opt--all';
      a.setAttribute('role', 'option');
      a.tabIndex = -1;
      a.setAttribute('aria-selected', 'false');
      a.id = 'srch-o0';
      a.href = `${this.dataset.searchUrl}?q=${encodeURIComponent(this.rewrite(raw))}`;
      a.textContent = this.dataset.tError;
      const group = document.createElement('div');
      group.className = 'srch-group srch-group--all';
      group.setAttribute('role', 'group');
      group.append(a);
      this.swapList([group]);
      this.input.setAttribute('aria-expanded', 'true');
      this.noneEl.hidden = true;
      this.statusEl.textContent = this.dataset.tError;
    }

    highlight(raw) {
      const soft = { water: 1, filter: 1, filters: 1, system: 1, systems: 1, the: 1, a: 1, for: 1, and: 1, of: 1, my: 1, to: 1 };
      const tokens = String(raw || '').toLowerCase().split(/[^a-z0-9]+/).filter((t) => t.length > 1 && !soft[t]).sort((a, b) => b.length - a.length);
      if (!tokens.length) return;
      /* word-start matches only, as in the prototype */
      const pattern = new RegExp(`(^|[^a-z0-9])(${tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'ig');
      this.listEl.querySelectorAll('[data-hl]').forEach((el) => {
        const text = el.textContent;
        const nodes = [];
        let last = 0;
        let m;
        pattern.lastIndex = 0;
        while ((m = pattern.exec(text))) {
          const start = m.index + m[1].length;
          if (start > last) nodes.push(document.createTextNode(text.slice(last, start)));
          const mark = document.createElement('mark');
          mark.textContent = m[2];
          nodes.push(mark);
          last = start + m[2].length;
          if (m[0].length === 0) pattern.lastIndex++;
        }
        if (!nodes.length) return;
        if (last < text.length) nodes.push(document.createTextNode(text.slice(last)));
        el.replaceChildren(...nodes);
      });
    }
  });
}
